// Icon-Section.js

var $ = require('jquery');

$(document).ready(function() {

    // adjust margin/height
    $(window).on('resize', function() {
        var maxIconHeight = 0;
        $('.icon-section .js-button img').each(function() {
            maxIconHeight = Math.max($(this).height(), maxIconHeight);
        });  
        $('.icon-section .js-button img').each(function() {
            var windowWidth = window.innerWidth;

            if(windowWidth <= 767){
                //$(this).css("margin-top",(maxIconHeight-$(this).height())/2);
                //$(this).css("margin-bottom",(maxIconHeight-$(this).height())/2);
                $(this).css("margin-top",0);
                $(this).css("margin-bottom",0); 
            } else {
                $(this).css("margin-top",maxIconHeight-$(this).height());
                $(this).css("margin-bottom",0);
            }
        });  
    }).trigger('resize');

    setTimeout(function() {
      $(window).trigger('resize');  
    }, 1000);
    /*
    var maxContentHeight = 0;
    $('.icon-section .content__text').each(function() {
        maxContentHeight = Math.max($(this).height(), maxContentHeight);
        console.log($(this).height());
    });  
    $('.icon-section .content__text').each(function() {
        $(this).css("margin-top",maxContentHeight-$(this).height());
    });  
    console.log(maxContentHeight);
    */
    // init

    var button = $('.icon-section .js-button');
    $('.icon-section .item__content').hide().addClass('-setup');
    $('.icon-section .js-button').attr('aria-expanded', false);

    var nbItemMax;
    var nbItem = $('.icon-section .layout__item').length;

    // Responsive...
    $(window).on('resize', function() {
        var windowWidth = window.innerWidth;

        if(windowWidth <= 767){ nbItemMax = 1; } 
        else if(windowWidth <= 1042) { nbItemMax = 3; }
        else { nbItemMax = 5; }

        var activeItem = $('.icon-section .layout__item.-active').attr('data-item');;
        setupGrid(nbItem, nbItemMax, activeItem);

    }).trigger('resize');


    // Buttons
    button.each(function() {

        $(this).on('click', function(){
            var open = $(this).parents('.layout__item').hasClass('-active');

            if(!open) {

                // Active Item
                var activeItem = $(this).parents('.icon-section__layout').find('.layout__item.-active');
                var activeContent = activeItem.find('.item__content');
                var activeButton = activeItem.find('.js-button');
    
                // New Item
                var item = $(this).parents('.layout__item');
                var content = $(this).parents('.layout__item').find('.item__content');
    
                // Grid
                var nb = $(this).parents('.layout__item').attr('data-item');
                setupGrid(nbItem, nbItemMax, nb);
    
                // Close Active Item
                if(activeItem.length != 0) {
                    activeButton.attr('aria-expanded', false);
                    activeItem.removeClass('-active');
                    toggleContent(activeContent, false);
                }
                
                // Open New Item
                $(this).attr('aria-expanded', true);
                item.addClass('-active');
                toggleContent(content, true);
                open = true;

            }
        });
    });
})


// - - - FUNCTION - - -


function toggleContent(content, open) { 
    content.show();
    var height = content[0].scrollHeight;
    
    if (open) {
        content.animate({ 'max-height': height }, 500, function() {
            content.show();
        });
    } else {
        content.animate({ 'max-height': 0 }, 500, function() {
            content.hide();
        });
    }  
}

function setupGrid(items, itemMax, activeItem) {
    var widthItem = '1fr';
    var widthItemActive = '2fr';

    var layoutValues = '';
    for (var i = 1; i <= items; i++) {
        if (activeItem == i) { layoutValues += widthItemActive + ' '; } 
        else { layoutValues += widthItem + ' '; }

        if(itemMax == i) { break; }
    }
    console.log(layoutValues);
    console.log(activeItem);

    $('.icon-section .icon-section__layout').css('grid-template-columns', layoutValues);
    $('.icon-section .icon-section__layout').css('transition', 'grid-template-columns, .5s');
}